/**
 * The data classes the PR-10D retention seam can purge. This list mirrors the
 * backend `PURGEABLE` registry (services/api/.../services/retention.py) exactly;
 * anything outside it is rejected fail-closed by the API.
 */
export type RetentionDataClass =
  | "gas_reading"
  | "ff_position"
  | "incident_audio"
  | "exposure_record"
  | "gateway_position"
  | "gateway_heartbeat";

export const PURGEABLE_DATA_CLASSES: {
  value: RetentionDataClass;
  label: string;
}[] = [
  { value: "gas_reading", label: "Gas readings" },
  { value: "ff_position", label: "Firefighter positions" },
  { value: "incident_audio", label: "Incident audio" },
  { value: "exposure_record", label: "Exposure records" },
  { value: "gateway_position", label: "Gateway positions" },
  { value: "gateway_heartbeat", label: "Gateway heartbeats" },
];

export function dataClassLabel(dataClass: string): string {
  return (
    PURGEABLE_DATA_CLASSES.find((d) => d.value === dataClass)?.label ?? dataClass
  );
}
